module.exports = __webpack_public_path__ + "img/home3.8dc601ba.svg";